import type { Resource } from '../../';
export const product_details_onBackorder: Resource = {"default":"On Backorder"};
